import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
	static targets = ["userRoleSection"]

	updateRole(event) {
		const checkbox = event.target
		const roleId = checkbox.dataset.roleId
		const userId = checkbox.dataset.userId
		const isNone = checkbox.dataset.isNone
		const checked = checkbox.checked

		fetch("/user-roles", {
			method: "POST",
			headers: {
				"X-CSRF-Token": document.querySelector('meta[name="csrf-token"]').content,
				"Content-Type": "application/json",
			},
			body: JSON.stringify({
				role_id: roleId,
				user_id: userId,
				is_none: isNone,
				assigned: checked,
			}),
		})
			.then(response => {
				if (!response.ok) throw new Error("Network response was not ok")
				try {
					this.dispatch("notify", { detail: { message: "The role was successfully updated!" } })
				} catch (e) {
					console.error("Success notification failed:", e)
				}
			})
			.catch(error => {
				console.error("Error:", error)
				checkbox.checked = !checked // Revert checkbox if request fails
				this.dispatch("notify", { detail: { message: "Failed to update role. Please try again!" } })
			})
	}

	updateAccessRole(event) {
		const form = event.target.form
		const role = event.target.value

		fetch(form.action, {
			method: "PATCH",
			headers: {
				'X-CSRF-Token': document.querySelector("meta[name='csrf-token']").content,
				"Content-Type": "application/json",
			},
			body: JSON.stringify({
				role: role,
			}),
		})
			.then(response => {
				if (!response.ok) throw new Error("Network response was not ok")
				try {
					this.dispatch("notify", { detail: { message: "The role was successfully updated!" } })
					this.toggleDisabledRoles(role)
				} catch (e) {
					console.error("Success notification failed:", e)
				}
			})
			.catch(() => {
				this.dispatch("notify", { detail: { message: "Failed to update role. Please try again!" } })
			})
	}

	toggleDisabledRoles(role) {
		const isPublic = (role === '0')
		this.userRoleSectionTargets.forEach(el => el.classList.toggle('disabled', isPublic))
	}
}